import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PrivateRoute from 'utils/PrivateRoute';
import { Authorization } from './containers/Authorization';
import { HiikoEnv } from './containers/HiikoEnv';
import HiikoEnvList from './containers/HiikoEnv/pages/HiikoEnvList/HiikoEnvList';

export const RouteConstants = {
  root: process.env.PUBLIC_URL + '/',
  hiikoEnv: {
    index: '/env/:envId',
    list: '/envList',
    createEnv: '/envList/create',
  },
  auth: {
    index: '/auth',
    login: '/auth/login',
    registration: '/auth/signup',
    resetPassword: '/auth/reset-password',
    authenticate: '/auth/authenticate',
  },
  company: {
    index: '/env/:envId(\\d+)/companies',
    list: '/env/:envId(\\d+)/companies/all',
    details: '/env/:envId(\\d+)/companies/d/:companyId(\\d+)',
  },
  task: {
    index: '/env/:envId(\\d+)/tasks',
    list: '/env/:envId(\\d+)/tasks/all',
    routesWithoutTask: '/env/:envId(\\d+)/tasks/routes-without-task',
    createTask: '/env/:envId(\\d+)/tasks/create',
    details: '/env/:envId(\\d+)/tasks/d/:taskId(\\d+)',
    // path for Task Details page which was opened from Field Tasks table
    // and back button should navigate to Field Tasks table
    detailsOpenedFromFieldTasks:
      '/env/:envId(\\d+)/tasks/d/:taskId(\\d+)/from-field/:fieldId(\\d+)',
    editTask: '/env/:envId(\\d+)/tasks/edit/:taskId(\\d+)',
    taskProgressUpdate: '/env/:envId(\\d+)/tasks/progress/:taskId(\\d+)',
  },
  user: {
    index: '/env/:envId(\\d+)/users',
    list: '/env/:envId(\\d+)/users/all',
    details: '/env/:envId(\\d+)/users/d/:userId(\\d+)',
  },
  cultures: {
    index: '/env/:envId(\\d+)/cultures',
    list: '/env/:envId(\\d+)/cultures/all',
    details: '/env/:envId(\\d+)/cultures/d/:cultureId(\\d+)',
    detailsByCompany:
      '/env/:envId(\\d+)/cultures/d/:cultureId(\\d+)/company/:companyId(\\d+)',
    editCulture: '/env/:envId(\\d+)/cultures/edit/:cultureId(\\d+)',
    editCompanyCulture:
      '/env/:envId(\\d+)/cultures/edit/:cultureId(\\d+)/company/:companyId(\\d+)',
    createCulture: '/env/:envId(\\d+)/cultures/create',
  },
  field: {
    index: '/env/:envId(\\d+)/fields',
    list: '/env/:envId(\\d+)/fields/all',
    details: '/env/:envId(\\d+)/fields/d/:fieldId(\\d+)',
    addField: '/env/:envId(\\d+)/fields/add-field',
    createField: '/env/:envId(\\d+)/fields/create-field',
    editField: '/env/:envId(\\d+)/fields/edit-field/:fieldId(\\d+)',
    createTaskOnField: '/env/:envId(\\d+)/fields/create-task/:fieldId(\\d+)',
  },
  usedResource: {
    index: '/env/:envId(\\d+)/used-resources',
  },
  resource: {
    index: '/env/:envId(\\d+)/resources',
    harvest: '/env/:envId(\\d+)/resources/harvest',
    harvestCulture:
      '/env/:envId(\\d+)/resources/harvest/culture/:cultureId(\\d+)',
    resourceAllocation: '/env/:envId(\\d+)/resources/resource-allocation',
    resourceAllocationTaskCategory:
      '/env/:envId(\\d+)/resources/resource-allocation/task-category/:taskCategoryId(\\d+)',
    resourceAllocationUsedResourceActionLog:
      '/env/:envId(\\d+)/resources/resource-allocation/task-category/:taskCategoryId(\\d+)/used-resource/:usedResourceId(\\d+)',
  },
  meteo: {
    index: '/env/:envId(\\d+)/meteo',
    forecast: '/env/:envId(\\d+)/meteo/forecast',
  },
  analytics: {
    index: '/env/:envId(\\d+)/analytics',
  },
  settings: {
    index: '/env/:envId(\\d+)/settings',
  },
  garage: {
    index: '/env/:envId(\\d+)/garage',
    transportList: '/env/:envId(\\d+)/garage/transport',
    implementList: '/env/:envId(\\d+)/garage/implement',
    employeeList: '/env/:envId(\\d+)/garage/employee',

    transportDetails:
      '/env/:envId(\\d+)/garage/company/:companyId(\\d+)/transport/:transportId(\\d+)',
    implementDetails:
      '/env/:envId(\\d+)/garage/company/:companyId(\\d+)/implement/:implementId(\\d+)',
    employeeDetails:
      '/env/:envId(\\d+)/garage/company/:companyId(\\d+)/employee/:employeeId(\\d+)',
  },
  recipe: {
    index: '/env/:envId(\\d+)/recipe',
    create: '/env/:envId(\\d+)/recipe/create',
    details: '/env/:envId(\\d+)/recipe/details/:recipeId(\\d+)',
    edit: '/env/:envId(\\d+)/recipe/edit/:recipeId(\\d+)',
  },
};

export const COMPANY_SELECT_DISABLED_ROUTES = [
  RouteConstants.company.index,

  RouteConstants.cultures.list,
  RouteConstants.cultures.details,
  RouteConstants.cultures.detailsByCompany,
  RouteConstants.cultures.editCulture,
  RouteConstants.cultures.editCompanyCulture,

  RouteConstants.garage.transportDetails,
  RouteConstants.garage.employeeDetails,
  RouteConstants.garage.implementDetails,

  RouteConstants.recipe.index,
];

export const HIIKO_ENV_SELECT_DISABLED_ROUTES = [
  RouteConstants.garage.transportDetails,
  RouteConstants.garage.employeeDetails,
  RouteConstants.garage.implementDetails,
];

export const SEASON_SELECT_DISABLED_ROUTES = [
  RouteConstants.company.index,

  RouteConstants.user.index,

  RouteConstants.meteo.index,

  RouteConstants.garage.index,

  RouteConstants.recipe.index,
];

export function RootRoutes() {
  return (
    <Switch>
      <Route path={RouteConstants.auth.index} component={Authorization} />
      <Route path={RouteConstants.hiikoEnv.index} component={HiikoEnv} />

      <PrivateRoute
        path={RouteConstants.hiikoEnv.list}
        component={HiikoEnvList}
        withLayout={false}
      />
      <PrivateRoute
        path={RouteConstants.hiikoEnv.createEnv}
        component={HiikoEnvList}
        withLayout={false}
      />

      <Redirect from="/" to={RouteConstants.hiikoEnv.list} />
    </Switch>
  );
}
